export default "__VITE_ASSET__CU28199A__"